export default __webpack_public_path__ + "static/media/photo--lg--games.29bb45fc.jpg";